import { t } from 'ember-intl';
import { HdsTextBody } from '@hashicorp/design-system-components/components';
import { CoreModalConfirm } from 'core/components';
import { boxPadding } from 'core/modifiers';

const Disable = <template>
  <CoreModalConfirm
    @confirmButtonText={{t "components.scim.disable.confirm-button"}}
    @confirmHelp={{t "components.scim.disable.help"}}
    @confirmLabel={{t "components.scim.disable.label"}}
    @confirmText={{t "components.scim.disable.confirm-text"}}
    @headerIcon="alert-diamond"
    @headerText={{t "components.scim.disable.header"}}
    @onCancel={{@onCancel}}
    @onSubmit={{@onSubmit}}
  >
    <:body>
      <HdsTextBody @color="primary" @size="200" @tag="span">
        <span>{{t "components.scim.disable.title"}}</span>
        <ol>
          <li>{{t "components.scim.disable.list-1"}}</li>
          <li>{{t "components.scim.disable.list-2"}}</li>
        </ol>
      </HdsTextBody>
      <HdsTextBody
        @color="primary"
        @size="200"
        @tag="p"
        {{boxPadding "0 0 lg 0"}}
      >
        {{t "components.scim.disable.description"}}
      </HdsTextBody>
    </:body>
  </CoreModalConfirm>
</template>;

export default Disable;
